module.exports = __webpack_public_path__ + "public/images/language_of_instruction_img.17255eea60390c596a52efce39268dbe.svg";